import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "24",
  height: "25",
  viewBox: "0 0 24 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M9.61133 19.2925L2.89426 12.2925L9.61133 5.29248",
      stroke: "#303333"
    }, null, -1),
    _createElementVNode("line", {
      x1: "3.26563",
      y1: "12.1836",
      x2: "20.9987",
      y2: "12.1836",
      stroke: "#303333"
    }, null, -1)
  ])))
}
export default { render: render }